import script from "./version-upgrade-notice-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./version-upgrade-notice-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./version-upgrade-notice-dialog.vue?vue&type=style&index=0&id=a5a099e6&lang=scss"
import "./version-upgrade-notice-dialog.vue?vue&type=style&index=1&id=a5a099e6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5a099e6"]])

export default __exports__